module.exports = __webpack_public_path__ + "../resources/img/installer_process0.92e1d393.png";